/**
 * isEventFromWithinElement is a utility function that is meant to be used in event handlers
 * to detect if a event originated within a specific element.
 *
 * @param event The event to be checked
 * @param element The DOM element to be checked
 * @returns true or false depending on whether or not the event came from within the element
 */
function isEventFromWithinElement(event, element) {
  if (element) {
    /* use the Event.composed API if available */
    if ('composed' in event && event.composed === true) {
      const eventPath = event.composedPath();
      return eventPath.includes(element);
    }

    /* Fallback to for the old Event.target API */
    if ('target' in event && event.target && typeof Node === 'function' && event.target instanceof Node) {
      return element.contains(event.target);
    }
  }
  return false;
}

export { isEventFromWithinElement as i };
//# sourceMappingURL=isEventFromWithinElement-BvBeBwSW.js.map
